import { render, staticRenderFns } from "./FriendsSelection.vue?vue&type=template&id=59fbde22&"
import script from "./FriendsSelection.vue?vue&type=script&lang=js&"
export * from "./FriendsSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports